import { REHYDRATE } from 'redux-persist';
import { ActionTypes } from '../constants';

const defaults: NotificationState = [];

export interface ActionType {
  type: string;
  payload: any;
}

export default (state: NotificationState = defaults, action: ActionType) => {
  switch (action.type) {
    case ActionTypes.UPDATE_NOTIFICATIONS: {
      return action.payload;
    }
    case REHYDRATE: {
      if (action.payload && action.payload.notifications) {
        return [...state, ...action.payload.notifications];
      }
      return state;
    }
    default:
      return state;
  }
};
